export default __webpack_public_path__ + "static/media/eliska.5eb8157a.png";